define.alias("checkout/components/payment/coupon", "settings/components/payment/coupon");